import { useState, useEffect, useRef } from "react";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import DocCommentDetails from "../documentComment/DocCommentDetails";
import { useLocation, useNavigate } from "react-router-dom";
import "./CcDocumentComment.scss";

const CcDocumentComent = () => {
  const [documentId, setDocumentId] = useState("");
  const [caseId, setCaseId] = useState("");
  const [commentOn, setCommentOn] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setDocumentId(params.get("documentId"));
    setCaseId(params.get("caseId"));
    setCommentOn(params.get("commentOn"));
  }, []);
  return (
    <div className="document-comment-box">
      <span className="path_line">
        <WidgetsOutlinedIcon style={{ height: "24px" }} /> &nbsp; &nbsp;/ &nbsp;
        &nbsp;{" "}
        <span
          onClick={() => navigate(`/Dashboard/EditCases?caseId=${caseId}`)}
          className="cursor-pointer"
        >
          Case Details
        </span>{" "}
        &nbsp; &nbsp;/ &nbsp; &nbsp; Document Comments
      </span>
      {documentId && (
        <div>
          <DocCommentDetails documentId={documentId} commentOn={commentOn} />
        </div>
      )}
    </div>
  );
};

export default CcDocumentComent;
